import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input,
  OnChanges,
  OnInit, Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

interface ItemsList {
  list: any[],
  displayKey: string
}

require('./bringoz-items-list-display.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-items-list-display',
  templateUrl: './bringoz-items-list-display.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozItemsListDisplayComponent implements OnInit, OnChanges {

  @Input() items?: string[];
  @Input() itemsObject?: any;
  @Input() itemsList?: ItemsList
  @Input() maxItems?: number = 2;
  @Input() prefix?: string;
  @Input() canCopy?: boolean;
  @Input() color?: string;
  @Input() isAllowRemove: boolean;
  @Input() isTransparentBackground: boolean;
  @Output() removeItem = new EventEmitter<string>();

  public viewItems: any;
  public extraItems: string[] = [];
  public isShowCopyButton: boolean;

  constructor() {
  }

  ngOnInit() {
    this.viewItems = [];

    if (this.itemsObject) {
      this.items = Object.values(this.itemsObject);
    } else if (this.itemsList) {
      this.items = this._getItemsByList(this.itemsList);
    }
    this._initItems(this.items);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.viewItems = [];
      if (this.itemsObject) {
        this.items = Object.values(this.itemsObject);
      } else if (this.itemsList) {
        this.items = this._getItemsByList(this.itemsList);
      }
      this._initItems(this.items);
    }
    if (changes.itemsMap && !changes.itemsMap.isFirstChange()) {
      this.viewItems = [];
      this.items = Object.values(this.itemsObject);
      this._initItems(this.items);
    }
    if (changes.itemsList && !changes.itemsList.isFirstChange()) {
      this.viewItems = [];
      this.items = this._getItemsByList(this.itemsList);
      this._initItems(this.items);
    }
  }


  private _getItemsByList(itemsList: ItemsList) {
    return itemsList.list
      ?.filter((item) => {
        return !!item[this.itemsList.displayKey];
      })
      .map((item) => {
        return item[this.itemsList.displayKey]
      });
  }

  private _initItems(items) {
    this.viewItems = [];
    this.extraItems = [];

    if (!items?.length) {
      return;
    }

    this.viewItems = this.maxItems ? items.filter((item, index) => {
      return index < this.maxItems
    }) : items;

    this.extraItems = items.slice(this.maxItems);
  }

}
